import { RootState } from "../..";

export const authSelector = (state: RootState) => state.auth;
